import React from "react";

// A color word that depends on the mode: on dark paper the ramps run dark → bright, so a caption's
// "darker is more" reads "brighter is more" there. HTML only (legends and captions), not SVG text.
// The dark: variant is bound to [data-theme="dark"] in app/assets/stylesheets/charts.css.
export default function ModeWord({ light, dark }) {
	return <><span className="dark:hidden">{light}</span><span className="hidden dark:inline">{dark}</span></>;
}
